exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h3[_v-42ea921d]{font-family:Open Sans}h4[_v-42ea921d]{padding-bottom:0;margin-bottom:7px}.h4-raleway[_v-42ea921d]{font-family:Raleway}.full-img[_v-42ea921d]{width:100%}.more-padding-top[_v-42ea921d]{padding-top:60px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-42ea921d&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/pages/About.vue
// module id = 426
// module chunks = 0